<template>
    <div>
        <v-card class="min-vh-90 d-flex flex-column">
            <v-card-title class="d-flex justify-content-between w-100 mb-4">
                <h5 v-if="mode === 'update'" class="ml-2 my-4">Modification d'une option</h5>
                <h5 v-else-if="mode === 'create'" class="ml-2 my-4">Création d'une option</h5>
                <v-btn icon @click="closeModal" class="ml-auto">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-stepper @change="setModalCurrentStep" non-linear :value="modalCurrentStep"
                           class="h-auto w-auto config-stepper">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            <div class="d-flex">
                                <v-icon class="mr-2">description</v-icon>
                                <span class="mt-auto mb-auto">Description</span>
                            </div>
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            <div class="d-flex">
                                <v-icon class="mr-2">euro</v-icon>
                                <span class="mt-auto mb-auto">Prix</span>
                            </div>
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            <div class="d-flex">
                                <v-icon class="mr-2">quiz</v-icon>
                                <span class="mt-auto mb-auto">Questions associées</span>
                            </div>
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            <div class="d-flex">
                                <v-icon class="mr-2">settings</v-icon>
                                <span class="mt-auto mb-auto">Configuration</span>
                            </div>
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-text-field
                              outlined
                              label="Nom de l'option"
                              v-model="option.name"
                              hide-details
                              class="mb-2"
                              :class="{'input-error': submitted && (option.name === null || option.name === '') }"
                            ></v-text-field>

                            <v-text-field
                              outlined
                              label="Note explicative"
                              v-model="option.description"
                              hide-details
                              class="mb-2"
                            ></v-text-field>

                            <v-autocomplete
                              label="Rubrique"
                              outlined
                              chips
                              v-model="option.level"
                              :items="optionLevels"
                              item-text="name"
                              no-data-text="Vous n'avez pas encore configuré de rubriques"
                              class="mb-2"
                              hide-details
                              deletable-chips
                              return-object
                            ></v-autocomplete>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-text-field
                              outlined
                              label="Prix"
                              v-model="option.price"
                              :disabled="usedInCampaign && mode === 'update'"
                              hide-details
                              type="number"
                              class="mb-2"
                              min="0"
                              :step="0.1"
                              suffix="€"
                              max="100000"
                              @keydown="filterInput"
                              :class="{'input-error': submitted && (option.price === null || option.price === '') }"
                            ></v-text-field>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-alert type="info"
                                     text
                                     class="container m-0 mr-3">
                                Vous pouvez choisir d'afficher l'option en fonction des réponses aux questions.
                                L'option sera visible pour les réponses cochées ci-après.
                            </v-alert>

                            <div v-if="criteriaFamilies.length === 0" class="my-8 text-center">
                                <span>Vous n'avez configuré aucune question</span>
                            </div>

                            <div v-else v-for="family in criteriaFamilies" class="w-100 mx-2 my-4">
                                <div class="d-flex justify-content-between">
                                <span>
                                    {{ family.label }}
                                </span>

                                    <div class="d-flex">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="selectAllCriterias(family, option)" class="mr-2"
                                                        v-on="on">
                                                    <v-icon small class="select-button">done_all</v-icon>
                                                </button>
                                            </template>
                                            <span>Sélectionner tout</span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="unselectAllCriterias(family, option)" class="mr-2"
                                                        v-on="on">
                                                    <v-icon small class="select-button">remove_done</v-icon>
                                                </button>
                                            </template>
                                            <span>Désélectionner tout</span>
                                        </v-tooltip>
                                    </div>
                                </div>

                                <v-select
                                  outlined
                                  chips
                                  :items="family.criterias"
                                  v-model="option.criterias"
                                  item-text="label"
                                  item-value="id"
                                  return-object
                                  hide-details
                                  deletable-chips
                                  multiple
                                  class="mr-2"
                                ></v-select>
                            </div>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <div class="d-flex" v-if="!(usedInCampaign && mode === 'update')">
                            <v-checkbox
                              label="Option réservable"
                              v-model="option.immediate"
                              :true-value="false"
                              :false-value="true"
                              hide-details
                              class="mb-2"
                            ></v-checkbox>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon class="ml-4 pt-3" v-on="on">help</v-icon>
                                    </template>
                                    <span>
                                        Le prestataire peut ajouter l'option à son adhésion mais celle-ci ne sera pas
                                        facturée immédiatement <br> et n'entrera donc pas dans le prix total de l'adhésion.
                                    </span>
                                </v-tooltip>

                            </div>

                            <div v-else-if="usedInCampaign && mode === 'update' && option.immediate" class="mb-8">
                                <v-icon class="mr-2">check_box_outline_blank</v-icon>
                                <span class="fake-disable-checkbox-label">
                                        Option réservable
                                    </span>

                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon class="ml-4" v-on="on">help</v-icon>
                                    </template>
                                    <span>
                                        Le prestataire peut ajouter l'option à son adhésion mais celle-cine sera pas
                                        facturée immédiatement br et n'entrera donc pas dans le prix total de l'adhésion.
                                    </span>
                                </v-tooltip>
                            </div>

                            <div v-else class="mb-8">
                                <v-icon class="mr-2" color="primary">check_box</v-icon>
                                <span class="fake-disable-checkbox-label">
                                        Option réservable
                                    </span>

                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon class="ml-4" v-on="on">help</v-icon>
                                    </template>
                                    <span>
                                        Le prestataire peut ajouter l'option à son adhésion mais celle-cine sera pas
                                        facturée immédiatement br et n'entrera donc pas dans le prix total de l'adhésion.
                                    </span>
                                </v-tooltip>
                            </div>


                            <v-checkbox
                              label="Option sélectionnable une fois maximum"
                              v-model="option.multiple"
                              v-if="!(usedInCampaign && mode === 'update')"
                              hide-details
                              class="mb-2"
                            ></v-checkbox>

                            <div v-else-if="usedInCampaign && mode === 'update' && !option.multiple">
                                <v-icon class="mr-2 mb-2">check_box_outline_blank</v-icon>
                                <span class="fake-disable-checkbox-label">
                                        Option sélectionnable une fois maximum
                                    </span>
                            </div>

                            <div v-else>
                                <v-icon class="mr-2" color="primary">check_box</v-icon>
                                <span class="fake-disable-checkbox-label">
                                        Option sélectionnable une fois maximum
                                    </span>
                            </div>

                            <v-checkbox
                              label="Masquer l'option"
                              v-model="option.enabled"
                              :true-value="false"
                              :false-value="true"
                              hide-details
                              class="mb-2"
                            ></v-checkbox>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>

            <v-card-actions class="text-center mt-auto mb-6">
                <v-btn class="default-button mx-auto" @click="checkNameAndPrice" v-if="mode === 'update'">
                    Modifier l'option
                </v-btn>
                <v-btn class="default-button mx-auto" @click="checkNameAndPrice" v-if="mode === 'create'">
                    Ajouter l'option à mon adhésion
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "CreateOptionModal",
    props: ["option", "mode"],
    data() {
        return {
            selectedLevel: null,
            submitted: false,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setOptionModal", "setModalCurrentStep"]),
        closeModal() {
            this.setOptionModal(false)
        },
        updateOption() {
            let criteriasIds = this.option.criterias && this.option.criterias.length > 0 ?
              this.option.criterias.map(function(criteria) {
                  return criteria.id
              }) : []

            let payload = {
                "cadhOptionId": this.option.id,
                "name": this.option.name,
                "price": this.option.price * 100,
                "multiple": this.option.multiple,
                "immediate": this.option.immediate,
                "description": this.option.description,
                "order": this.option.order,
                "enabled": this.option.enabled,
                "levelId": this.option.level ? this.option.level.id : null,
                "criteriasIds": criteriasIds,
            }

            this.$global.loading = true

            this.setOptionModal(false)

            this.$store.dispatch("cadhConfig/updateOption", payload)

            this.$global.loading = false
        },
        createOption() {
            let criteriasIds = this.option.criterias.length > 0 ?
              this.option.criterias.map(criteria => criteria.id) : []

            let payload = {
                "cadhConfigId": this.cadhConfig.id,
                "name": this.option.name,
                "price": this.option.price * 100,
                "multiple": this.option.multiple,
                "immediate": this.option.immediate,
                "description": this.option.description,
                "order": this.option.order,
                "enabled": this.option.enabled,
                "levelId": this.option.level ? this.option.level.id : null,
                "criteriasIds": criteriasIds,
            }

            this.$global.loading = true

            this.setOptionModal(false)

            this.$store.dispatch("cadhConfig/createOption", payload)

            this.$global.loading = false
        },
        checkNameAndPrice() {
            this.submitted = true
            let checkName = this.option.name !== null && this.option.name !== ""

            let checkPrice = this.option.price !== null && this.option.price !== ""

            if (!checkName) {
                this.setModalCurrentStep("1")
            } else if (!checkPrice) {
                this.setModalCurrentStep("2")
            }

            if (checkName && checkPrice && this.mode === "create") {
                this.submitted = false
                this.createOption()
            } else if (checkName && checkPrice && this.mode === "update") {
                this.submitted = false
                this.updateOption()
            }
        },
        filterInput(event) {
            const invalidChars = ["e", "E", "+", "-"]

            if (invalidChars.includes(event.key)) {
                event.preventDefault()
            }
        },
        selectAllCriterias(family, option) {
            let optionCriteriasIds = option.criterias.map(crit => crit.id)

            family.criterias.forEach(criteria => {
                if (!optionCriteriasIds.includes(criteria.id)) {
                    option.criterias.push(criteria)
                }
            })
        },
        unselectAllCriterias(family, option) {
            family.criterias.forEach(criteria => {
                let optionCriteriasIds = option.criterias.map(crit => crit.id)

                if (optionCriteriasIds.includes(criteria.id)) {
                    let index = optionCriteriasIds.indexOf(criteria.id)

                    if (index > -1) {
                        option.criterias.splice(index, 1)
                    }
                }
            })
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "optionModal", "usedInCampaign", "modalCurrentStep", "criteriaFamilies",
            "optionLevels"]),
    },
}
</script>